import { useFormik } from "formik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const instanceFilterStore = makeObservable({});
const instanceNavigationStore = createSearchResultNavigationStore();

const useInstanceFilters = onSubmit => {
  const formik = useFormik({
    initialValues: {
      artistRef: { operator: "like" },
      limit: 50,
      offset: 0,
      statusId: { operator: "in" },
      tab: "consignments",
      sort1: { operator: "ASC" },
      sort2: { operator: "ASC" },
      sort3: { operator: "ASC" },
      _condition: { statusId: { operator: "in" } },
      _edition: {
        _artwork: {
          categoryId: { operator: "in" },
          classId: { operator: "eq" },
          medium: { operator: "like" },
          series: { operator: "like" },
          title: { operator: "like" },
        },
        number: {
          operator: "eq",
        },
      },
    },
    onSubmit: values => {
      if (onSubmit) {
        onSubmit(values);
      }
    },
  });

  const filterKeys = ["tab"];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    // convert formik values to filter and update store
    instanceFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { instanceFilterStore, instanceNavigationStore, useInstanceFilters };
